import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=e19d8bd6&scoped=true&"
import script from "./Notice.vue?vue&type=script&lang=js&"
export * from "./Notice.vue?vue&type=script&lang=js&"
import style0 from "./Notice.vue?vue&type=style&index=0&id=e19d8bd6&prod&lang=scss&scoped=true&"
import style1 from "./Notice.vue?vue&type=style&index=1&id=e19d8bd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19d8bd6",
  null
  
)

export default component.exports